import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import { InspectionDeviationResultDto } from "@/types";
import Accordion from "@/components/organisms/AccordionDrawer";
import Divider from "@/components/atoms/Divider";
import { useInspectionFormat } from "@/components/organisms/InspectionModal/useInspectionFormat";
import { DeviationDecision, DeviationHeader, InspectionPhotos, Row } from "./TabParts";

interface DeviationProductsAccordionProps {
  /** The inspection's deviations of kind PRODUCT. */
  deviations: InspectionDeviationResultDto[];
  isBuyer: boolean;
}

/** The deviation products registered in the inspection: weight taken off the order, at the buyer's own price. */
export default function DeviationProductsAccordion({ deviations, isBuyer }: DeviationProductsAccordionProps) {
  const { t } = useTranslation();
  const format = useInspectionFormat();

  return (
    <Accordion initiallyOpen title={t("inspections:deviations.productsTitle")}>
      {deviations.map((deviation, index) => (
        <Fragment key={deviation.id}>
          {index > 0 && <Divider margin={false} />}
          <Grid p={20} data-testid="inspection-product-deviation">
            <DeviationHeader deviation={deviation} />
            <Row label={t("inspections:drawer.deviationWeight")}>
              {`${format.number(deviation.weightKg ?? deviation.registeredNumber)} kg`}
            </Row>
            <Row label={t("inspections:drawer.unitPrice")}>
              {format.unitPrice(deviation.unitPrice, deviation.currencyType, format.deviationUnit(deviation.unitCode))}
            </Row>
            <Row label={t("inspections:deviations.cost")}>{format.amount(deviation.cost, deviation.currencyType)}</Row>
            <Row label={t("inspections:photos.label")}>
              <InspectionPhotos photoIds={deviation.photoIds} />
            </Row>
            <DeviationDecision deviation={deviation} isBuyer={isBuyer} />
          </Grid>
        </Fragment>
      ))}
    </Accordion>
  );
}
